<template>
  <div class="the-navbar__user-meta flex items-center" v-if="$store.getters.userData">

    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{ $store.getters.userData.name + " " + $store.getters.userData.l_name }}</p>
      <small>-</small>
    </div>

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">

      <div class="con-img ml-3">
        <img src="@/assets/images/portrait/small/empty-profile-picture.png" alt="user-img" width="40" height="40" class="rounded-full shadow-md cursor-pointer block" />
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">

          <li v-if="this.$store.state.theme !== 'dark'" class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="changeTheme">
            <feather-icon icon="MoonIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">{{$t('ChangeTheme')}}</span>
          </li>

          <li v-else class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white" @click="changeTheme">
            <feather-icon icon="SunIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">{{$t('ChangeTheme')}}</span>
          </li>

          <vs-divider class="m-1" />

          <li class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
              @click="logout">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">{{$t('Logout')}}</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  computed: {
    activeUserInfo() {
      return this.$store.state.AppActiveUser
    }
  },
  methods: {
    logout() {
      const thisIns = this;
      thisIns.$store.dispatch('setLoginStatus', false);
      this.$http.get('/api/v1/logout/')
              .then(function () {
                document.body.style.zoom = "100%";
                thisIns.$router.push('/login')
              })
              .catch(function (error) {
                thisIns.$vs.notify({
                  title:'Error',
                  text: error,
                  color:'danger',
                  iconPack: 'feather',
                  icon:'icon-alert-circle'})
              });
    },
    changeTheme() {
      const thisIns = this;
      this.$http.get('/api/v1/changeTheme/')
              .then(function () {
                if(thisIns.$store.state.theme === 'dark'){
                  thisIns.$store.dispatch('updateTheme', "light");
                }else{
                  thisIns.$store.dispatch('updateTheme', "dark");
                }
              })
              .catch(function (error) {
                thisIns.$vs.notify({
                  title:'Error',
                  text: error,
                  color:'danger',
                  iconPack: 'feather',
                  icon:'icon-alert-circle'})
              });
    },
  }
}
</script>
